import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Spin, Row, Col, theme, Typography, Checkbox, Grid, Divider, Flex } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import _ from 'lodash';

import { MessageContext } from '../../../layouts/NavigationLayout';
import GeneralHelper from '../../../helpers/general';
import Countries from '../../../constants/Countries';
import AssetHelper from '../../../helpers/asset';
import Confirmation from '../../../components/Confirmation';
import LabelHelper from '../../../helpers/label';
import ButtonGroupComponent from './ButtonGroupComponent';

const { Text, Link } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;

const ReviewAndSubmissionView = (props) => {
	const [understandCheck, setUnderstandCheck] = useState(false);
	const [herebyCheck, setHerebyCheck] = useState(false);
	const [agreeCheck, setAgreeCheck] = useState(false);
	const [readAndAgreeCheck, setReadAndAgreeCheck] = useState(false);
	const [declinedCheck, setDeclinedCheck] = useState(false);
	const [confirmation, setConfirmation] = useState(false);

	const history = useHistory();
	const { token } = useToken();
	const messageApi = useContext(MessageContext);
	const screens = useBreakpoint();

	const query = GeneralHelper.getParamsFromUrl();
	const { application_id: applicationId } = query || {};
	const { colorPrimary } = token;

	const { getApplication, reviewAndSubmissionPageProps, submitApplication,
		resetApplicationPage, resetApplicationMeta, setHasUnsavedChanges } = props;
	const { application, loading, loadingSubmit, meta } = reviewAndSubmissionPageProps;
	const currentStep = _.get(application, 'current_step');
	const { display_id, personal_info, education_bg, information, document, referee_info } = application || {};
	const educationBgUnderGrad = education_bg && education_bg.length > 0 ? education_bg[0] : {};
	const educationBgPostGrad = education_bg && education_bg.length === 2 ? education_bg[1] : {};
	const firstReferee = referee_info && referee_info.length > 0 ? referee_info[0] : {};
	const secondReferee = referee_info && referee_info.length === 2 ? referee_info[1] : {};

	useEffect(() => {
		setHasUnsavedChanges(false);
		if (applicationId) {
			getApplication(applicationId);
		} else {
			history.push('/application?step=0');	//	return to step 0 if applicationId not exist
		}
		return () => {
			resetApplicationPage();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (application) {
			if (application.status === 'submitted') {
				setUnderstandCheck(true);
				setHerebyCheck(true);
				setAgreeCheck(true);
				setReadAndAgreeCheck(true);
				setHasUnsavedChanges(false);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [application]);

	useEffect(() => {
		if (!_.isNil(meta)) {
			if (meta.code === 200) {
				history.push(`/application?step=7&application_id=${applicationId}`);
			} else {
				messageApi.open({
					type: 'error',
					content: `${meta.message}`,
					duration: 2.5
				});
			}
		}
		return () => {
			resetApplicationMeta();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	const getEnglishProfScore = () => {
		let score;
		if (!_.isNil(educationBgUnderGrad.ielts_score))
			score = educationBgUnderGrad.ielts_score;
		else if (!_.isNil(educationBgUnderGrad.toefl_score))
			score = educationBgUnderGrad.toefl_score;
		else if (!_.isNil(educationBgUnderGrad.english_prof_others_score))
			score = educationBgUnderGrad.english_prof_others_score;
		else
			score = 'N/A';

		return score;
	};

	const getCountryLabel = (name) => {
		const country = Countries.find(item => item.value === name);
		return country ? country.label : null;
	};

	const getYearOfStudy = (value) => {
		if (LabelHelper.yearOfStudy(value).length > 0) {
			return LabelHelper.yearOfStudy(value);
		} else {
			return value;
		}
	};


	const capitalizeFirstLetter = (str) => {
		return str.charAt(0).toUpperCase() + str.slice(1);
	};

	const englishProfScore = getEnglishProfScore();

	const getSaveDisabled = () => {
		let saveDisabled = false;
		if (
			!_.isEmpty(personal_info) &&
			personal_info.last_name &&
			personal_info.first_name &&
			personal_info.preferred_name &&
			personal_info.gender &&
			personal_info.birth_date &&
			personal_info.birth_place &&
			personal_info.require_visa &&
			personal_info.email &&
			personal_info.phone &&
			personal_info.street &&
			personal_info.country &&
			!_.isEmpty(educationBgUnderGrad) &&
			educationBgUnderGrad.institution &&
			educationBgUnderGrad.country &&
			educationBgUnderGrad.school &&
			educationBgUnderGrad.program &&
			educationBgUnderGrad.mode &&
			educationBgUnderGrad.expected_completion_date &&
			_.isNumber(educationBgUnderGrad.current_gpa) &&
			educationBgUnderGrad.highest_score &&
			(!_.isEmpty(educationBgPostGrad) ?
				educationBgPostGrad.institution &&
				educationBgPostGrad.country &&
				educationBgPostGrad.school &&
				educationBgPostGrad.program &&
				educationBgPostGrad.mode &&
				educationBgPostGrad.expected_completion_date &&
				_.isNumber(educationBgPostGrad.current_gpa) &&
				educationBgPostGrad.highest_score : true) &&
			!_.isEmpty(information) &&
			information.program_first_choice &&
			information.program_second_choice &&
			information.reason &&
			!_.isEmpty(firstReferee) &&
			firstReferee.salutation &&
			firstReferee.last_name &&
			firstReferee.first_name &&
			firstReferee.position &&
			firstReferee.department &&
			firstReferee.organization &&
			firstReferee.relationship &&
			firstReferee.email &&
			(!_.isEmpty(secondReferee) ?
				secondReferee.salutation &&
				secondReferee.last_name &&
				secondReferee.first_name &&
				secondReferee.position &&
				secondReferee.department &&
				secondReferee.organization &&
				secondReferee.relationship &&
				secondReferee.email : true)
		) {
			saveDisabled = false;
		} else {
			saveDisabled = true;
		}
		return saveDisabled;
	};

	if (loading) {
		return (
			<div
				style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
			>
				<Spin />
			</div>
		);
	}
	const submitDisabled = !_.isEmpty(application) ? getSaveDisabled() : false;
	return (
		<>
			<Row>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<div style={{ width: '100%' }}>
						<Divider />
					</div>
				</Col>
			</Row>

			<Row style={{ marginBottom: 20 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
					>
						Application ID - {display_id}
					</Text>
				</Col>
			</Row>
			<Row align="middle">
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
					style={{ alignItems: 'center' }}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Text
							level={2}
							style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
						>Step 2 - Personal Particulars &nbsp;
						</Text>
						{
							application && application.status === 'draft' ? <Link
								onClick={() => history.push(`application?step=1&application_id=${applicationId}`)}
							>
								<FontAwesomeIcon
									icon={faEdit}
									fontSize={15}
								/>
							</Link> : null
						}
					</div>
				</Col>
			</Row>
			<Row
				gutter={[80, 0]}
				style={{ marginTop: 18 }}
			>
				<Col
					xl={{ span: 11, offset: 1 }}
					lg={{ span: 11, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Row>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							Personal Particulars
						</Text>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 18 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Family Name / Last Name</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.last_name ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{personal_info && personal_info.last_name ? personal_info.last_name : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Given Name / First Name</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.first_name ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400 }}
							>{personal_info && personal_info.first_name ? personal_info.first_name : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Preferred Name</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.preferred_name ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400 }}
							>{personal_info && personal_info.preferred_name ? personal_info.preferred_name : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Name in Chinese</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text style={{ fontSize: 14, fontWeight: 400 }}>{!_.isNil(personal_info) ? (!_.isEmpty(personal_info.chinese_name) ? personal_info.chinese_name : '-') : '-'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Gender</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.gender ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400 }}
							>{personal_info && personal_info.gender ? LabelHelper.gender(personal_info.gender) : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Date of Birth</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.birth_date ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400 }}
							>{personal_info && personal_info.birth_date ? dayjs(personal_info.birth_date).format('YYYY-MM') : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Place of Birth</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.birth_date ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400 }}
							>{personal_info && personal_info.birth_date ? LabelHelper.country(personal_info.birth_place) : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Require an entry visa to Hong Kong?</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.require_visa ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400 }}
							>{personal_info && personal_info.require_visa ? capitalizeFirstLetter(personal_info.require_visa) : 'This field is required'}</Text>
						</Col>
					</Row>
				</Col>
				<Col
					xl={12}
					lg={12}
					md={24}
					sm={24}
					xs={24}
				>
					<Row style={{ marginTop: ((!screens.xxl && !screens.xl && !screens.lg) & (screens.md || screens.sm || screens.xs)) ? 18 : 0 }}>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							Personal Identity
						</Text>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 18 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Passport / EEP Number</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}>{!_.isNil(personal_info) ? (!_.isEmpty(personal_info.passport_num) ? personal_info.passport_num : '-') : '-'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Country of Issue</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}>{!_.isNil(personal_info) ? (!_.isEmpty(personal_info.country_issue) ? LabelHelper.country(personal_info.country_issue) : '-') : '-'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Date of Expiry</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}>{!_.isNil(personal_info) ? (!_.isEmpty(personal_info.expiry_date) ? dayjs(personal_info.expiry_date).format('YYYY-MM-DD') : '-') : '-'}</Text>
						</Col>
					</Row>

					<Row style={{ marginTop: 18 }}>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							Contact Information
						</Text>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 18 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Email Address</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.email ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{personal_info && personal_info.email ? personal_info.email : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Contact Phone No.</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={personal_info && personal_info.phone ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{personal_info && personal_info.phone ? personal_info.phone : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Correspondence Address</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Row>
								<Col span={24}>
									<Text style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}>{!_.isNil(personal_info) ? personal_info.building : '-'}</Text>
								</Col>
								<Col span={24}>
									<Text
										type={personal_info && personal_info.street ? '' : 'danger'}
										style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
									>{personal_info && personal_info.street ? personal_info.street : 'This field is required'}</Text>
								</Col>
								<Col span={24}>
									<Text
										type={personal_info && personal_info.country ? '' : 'danger'}
										style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
									>{personal_info && personal_info.country ? personal_info.country : 'This field is required'}</Text>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Personal Homepage URL (optional)</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							{
								!_.isNil(personal_info) ? (!_.isEmpty(personal_info.personal_url) ?
									<Link
										style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
										onClick={() => window.open(personal_info.personal_url, '_blank')}
									>{personal_info.personal_url}
									</Link> : '-') : '-'
							}
						</Col>
					</Row>
				</Col>
			</Row >

			<Row
				align="middle"
				style={{ marginTop: 32 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Text
							level={2}
							style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
						>Step 3 - Education Background &nbsp;
						</Text>
						{
							application && application.status === 'draft' ? <Link
								onClick={() => history.push(`application?step=2&application_id=${applicationId}`)}
							>
								<FontAwesomeIcon
									icon={faEdit}
									fontSize={15}
								/></Link> : null
						}
					</div>
				</Col>

			</Row>
			<Row
				gutter={[80, 0]}
				style={{ marginTop: 18 }}
			>
				<Col
					xl={{ span: 11, offset: 1 }}
					lg={{ span: 11, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Row>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							Undergraduate Studies
						</Text>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 18 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Name of Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.institution ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.institution ? educationBgUnderGrad.institution : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Country / Region of Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.country ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.country ? getCountryLabel(educationBgUnderGrad.country) : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Faculty / School</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.school ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.school ? educationBgUnderGrad.school : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Program of Study</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.program ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.program ? educationBgUnderGrad.program : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Mode of Study</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.mode ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.mode ? LabelHelper.modeOfStudy(educationBgUnderGrad.mode) : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Current Year of Study</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.current_year ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.current_year ? getYearOfStudy(educationBgUnderGrad.current_year) : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Expected Date of Completion / Date of Graduation</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.expected_completion_date ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.expected_completion_date ? dayjs(educationBgUnderGrad.expected_completion_date).format('YYYY-MM') : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Current GPA / Average Mark</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && _.isNumber(educationBgUnderGrad.current_gpa) ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && _.isNumber(educationBgUnderGrad.current_gpa) ? educationBgUnderGrad.current_gpa?.toFixed(2) : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Highest Score in the Grading Scale of Your Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={educationBgUnderGrad && educationBgUnderGrad.highest_score ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{educationBgUnderGrad && educationBgUnderGrad.highest_score ? educationBgUnderGrad.highest_score : 'This field is required'}
							</Text>
						</Col>
					</Row>
				</Col>
				<Col
					xl={12}
					lg={12}
					md={24}
					sm={24}
					xs={24}
				>
					<Row style={{ marginTop: ((!screens.xxl && !screens.xl && !screens.lg) & (screens.md || screens.sm || screens.xs)) ? 18 : 0 }}>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							Postgraduate Studies (if applicable)
						</Text>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 18 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Name of Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.institution ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.institution ? educationBgPostGrad.institution : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Country / Region of Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.country ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.country ? getCountryLabel(educationBgPostGrad.country) : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Faculty / School</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.school ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.school ? educationBgPostGrad.school : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Program of Study</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.program ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.program ? educationBgPostGrad.program : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Mode of Study</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.mode ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.mode ? LabelHelper.modeOfStudy(educationBgPostGrad.mode) : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Current Year of Study</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.current_year ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.current_year ? getYearOfStudy(educationBgPostGrad.current_year) : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Expected Date of Completion / Date of Graduation</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.expected_completion_date ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.expected_completion_date ? dayjs(educationBgPostGrad.expected_completion_date).format('YYYY-MM') : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Current GPA / Average Mark</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : _.isNumber(educationBgPostGrad.current_gpa) ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : _.isNumber(educationBgPostGrad.current_gpa) ? educationBgPostGrad.current_gpa.toFixed(2) : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Highest Score in the Grading Scale of Your Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(educationBgPostGrad) ? '' : educationBgPostGrad.highest_score ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(educationBgPostGrad) ? '-' : educationBgPostGrad.highest_score ? educationBgPostGrad.highest_score : 'This field is required'}
							</Text>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row style={{ marginTop: 18 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 20, fontWeight: 510 }}
					>
						English Proficiency
					</Text>
				</Col>

			</Row>
			<Row style={{ marginTop: 21 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Flex
						wrap="reference"
					>
						<div>
							<Flex gap={5}>
								<div>
									<Checkbox
										checked={education_bg && education_bg.length > 0 && !_.isNil(educationBgUnderGrad.toefl_score)}
										disabled={true}
									>
									</Checkbox>
								</div>
								<div>
									<Text>
										TOEFL (Paper-based Test)
									</Text>
								</div>
							</Flex>
						</div>
						<div style={{ height: '100%', marginLeft: 10, marginRight: 10 }}>
							<Text>/</Text>
						</div>
						<div>
							<Flex gap={5}>
								<div>
									<Checkbox
										checked={education_bg && education_bg.length > 0 && !_.isNil(educationBgUnderGrad.ielts_score)}
										disabled={true}
									>
									</Checkbox>
								</div>
								<div>
									<Text>
										IELTS (Academic Module)
									</Text>
								</div>
							</Flex>
						</div>
						<div style={{ height: '100%', marginLeft: 10, marginRight: 10 }}>
							<Text>/</Text>
						</div>
						<div>
							<Flex gap={5}>
								<div>
									<Checkbox
										checked={education_bg && education_bg.length > 0 && !_.isNil(educationBgUnderGrad.english_prof_others_score)}
										disabled={true}
									>
									</Checkbox>
								</div>
								<div>
									<Text>
										Others {educationBgUnderGrad.english_prof_others ? `(${educationBgUnderGrad.english_prof_others})` : ''}
									</Text>
								</div>
							</Flex>
						</div>
					</Flex>
				</Col>
			</Row>
			<Row style={{ marginTop: 14 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<div style={{ marginLeft: 24 }}>
						Score / Level: {englishProfScore}
					</div>
				</Col>
			</Row>
			<Row style={{ marginTop: 12 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Flex gap={5}>
						<div>
							<Checkbox
								checked={education_bg && education_bg.length > 0 && (!_.isNil(educationBgUnderGrad.user_english_first_lang) ? educationBgUnderGrad.user_english_first_lang : false)}
								disabled={true}
							/>
						</div>
						<div>
							<Text>
								Your first language is English
							</Text>
						</div>
					</Flex>
				</Col>
			</Row>
			<Row style={{ marginTop: 12 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Flex gap={5}>
						<div>
							<Checkbox
								checked={education_bg && education_bg.length > 0 && (!_.isNil(educationBgUnderGrad.institution_english_first_lang) ? educationBgUnderGrad.institution_english_first_lang : false)}
								disabled={true}
							/>
						</div>
						<div>
							<Text>
								Your bachelor’s degree (or equivalent qualification) was / will be awarded by an institution where the medium of instruction is English.
							</Text>
						</div>
					</Flex>
				</Col>
			</Row>

			<Row
				align="middle"
				style={{ marginTop: 32 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Text
							level={2}
							style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
						>Step 4 - Application Information &nbsp;
						</Text>
						{
							application && application.status === 'draft' ? <Link onClick={() => history.push(`application?step=3&application_id=${applicationId}`)}>
								<FontAwesomeIcon
									icon={faEdit}
									fontSize={15}
								/></Link> : null
						}
					</div>
				</Col>
			</Row>
			<Row
				gutter={[80, 0]}
				style={{ marginTop: 18 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Row>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							Application Information
						</Text>
					</Row>
					<Row
						style={{ marginTop: 18 }}
					>
						<Col
							xl={7}
							lg={7}
							md={7}
							sm={12}
							xs={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Program of Interest (First Choice)</Text>
						</Col>
						<Col
							xl={16}
							lg={16}
							md={16}
							sm={11}
							xs={11}
							offset={1}
						>
							<Text
								type={information && information.program_first_choice ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>
								{
									information && information.program_first_choice ? (information.program_first_choice !== 'Others' ?
										information.program_first_choice : information.other_program_first_choice) : 'This field is required'
								}
							</Text>
						</Col>
					</Row>
					<Row
						style={{ marginTop: 11 }}
					>
						<Col
							xl={7}
							lg={7}
							md={7}
							sm={12}
							xs={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Program of Interest (Second Choice)</Text>
						</Col>
						<Col
							xl={16}
							lg={16}
							md={16}
							sm={11}
							xs={11}
							offset={1}
						>
							<Text
								type={information && information.program_second_choice ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>
								{
									information && information.program_second_choice ? (information.program_second_choice !== 'Others' ?
										information.program_second_choice : information.other_program_second_choice) : 'This field is required'
								}
							</Text>
						</Col>
					</Row>
					<Row
						style={{ marginTop: 11 }}
					>
						<Col
							xl={7}
							lg={7}
							md={7}
							sm={12}
							xs={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Program of Interest (Third Choice)</Text>
						</Col>
						<Col
							xl={16}
							lg={16}
							md={16}
							sm={11}
							xs={11}
							offset={1}
						>
							<Text style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}>{!_.isNil(information) ? (information.program_third_choice !== 'Others' ? information.program_third_choice : information.other_program_third_choice) : '-'}</Text>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row style={{ marginTop: 25 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text style={{ fontSize: 14, fontWeight: 510 }}>Reason(s) of applying for the Summer Camp (A maximum of 400 words in English)</Text>
				</Col>
			</Row>
			<Row style={{ marginTop: 20 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						type={information && information.reason ? '' : 'danger'}
						style={{ fontSize: 14, fontWeight: 400, whiteSpace: 'pre-line' }}
					>{information && information.reason ? information.reason : 'This field is required'}</Text>
				</Col>
			</Row>

			<Row>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<div style={{ width: '100%', marginTop: 41 }}>
						<Divider />
					</div>
				</Col>
			</Row>

			<Row
				align="middle"
				style={{ marginTop: 32 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Text
							level={2}
							style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
						>Step 5 - Supporting Documents &nbsp;
						</Text>
						{
							application && application.status === 'draft' ? <Link onClick={() => history.push(`application?step=4&application_id=${applicationId}`)}>
								<FontAwesomeIcon
									icon={faEdit}
									fontSize={15}
								/></Link> : null
						}
					</div>
				</Col>
			</Row>

			<Row style={{ marginTop: 18 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 20, fontWeight: 510 }}
					>
						Supporting Documents
					</Text>
				</Col>

			</Row>
			<Row
				gutter={[80, 0]}
				style={{ marginTop: 18 }}
			>
				<Col
					xl={{ span: 11, offset: 1 }}
					lg={{ span: 11, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>

					<Row
						justify="space-between"
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Your Resume / CV</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							{
								(document && document.cv_asset) ? <Link onClick={() => _.get(document, 'cv_asset._id') && window.open(AssetHelper.getDownloadUrl(document.cv_asset._id))}>
									{document.cv_asset.dl_file_name}
								</Link> : '-'
							}
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Grading System of Home Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							{
								(document && document.grading_asset) ? <Link onClick={() => _.get(document, 'grading_asset._id') && window.open(AssetHelper.getDownloadUrl(document.grading_asset._id))}>
									{document.grading_asset.dl_file_name}
								</Link> : '-'
							}
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Proof of English Proficiency</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							{
								(document && document.english_prof_asset) ? <Link onClick={() => _.get(document, 'english_prof_asset._id') && window.open(AssetHelper.getDownloadUrl(document.english_prof_asset._id))}>
									{document.english_prof_asset.dl_file_name}
								</Link> : '-'
							}
						</Col>
					</Row>
				</Col>
				<Col
					xl={12}
					lg={12}
					md={24}
					sm={24}
					xs={24}
				>
					<Row
						justify="space-between"
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Official Transcript(s) and/or Degree Certificate(s)</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							{
								_.get(document, 'transcript_of_records.length') > 0 ? _.get(document, 'transcript_of_records').map((record, index) => {
									return (
										<div key={record.asset._id}>
											<Link onClick={() => window.open(AssetHelper.getDownloadUrl(record.asset._id))}>
												{record.asset.dl_file_name}
											</Link>{_.get(document, 'transcript_of_records.length') !== index + 1 ? <span>, </span> : null}
										</div>
									);
								}) : '-'
							}
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Other Document(s)</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							{
								_.get(document, 'other_documents.length') > 0 ? _.get(document, 'other_documents').map((record, index) => {
									return (
										<div key={record.asset._id}>
											<Link onClick={() => window.open(AssetHelper.getDownloadUrl(record.asset._id))}>
												{record.asset.dl_file_name}
											</Link>{_.get(document, 'other_documents.length') !== index + 1 ? <span>, </span> : null}
										</div>
									);
								}) : '-'
							}
						</Col>
					</Row>
				</Col>
			</Row>

			<Row
				align="middle"
				style={{ marginTop: 32 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<Text
							level={2}
							style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
						>Step 6 - Information of Referees &nbsp;
						</Text>
						{
							application && application.status === 'draft' ? <Link onClick={() => history.push(`application?step=5&application_id=${applicationId}`)}>
								<FontAwesomeIcon
									icon={faEdit}
									fontSize={15}
								/></Link> : null
						}
					</div>
				</Col>
			</Row>
			<Row
				gutter={[80, 0]}
				style={{ marginTop: 18 }}
			>
				<Col
					xl={{ span: 11, offset: 1 }}
					lg={{ span: 11, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Row>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							The First Referee
						</Text>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 18 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Salutation</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.salutation ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.salutation ? firstReferee.salutation : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Family Name / Last Name</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.last_name ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.last_name ? firstReferee.last_name : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Given Name / First Name</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.first_name ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.first_name ? firstReferee.first_name : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Position</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.position ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.position ? firstReferee.position : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Department / Unit</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.department ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.department ? firstReferee.department : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.organization ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.organization ? firstReferee.organization : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Relationship with Applicant</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.relationship ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.relationship ? firstReferee.relationship : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Institutional Email</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={firstReferee && firstReferee.email ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{firstReferee && firstReferee.email ? firstReferee.email : 'This field is required'}</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Contact No.</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text style={{ fontSize: 14, fontWeight: 400 }}>{firstReferee && firstReferee.phone ? firstReferee.phone : '-'}</Text>
						</Col>
					</Row>
				</Col>
				<Col
					xl={12}
					lg={12}
					md={24}
					sm={24}
					xs={24}
				>
					<Row style={{ marginTop: ((!screens.xxl && !screens.xl && !screens.lg) & (screens.md || screens.sm || screens.xs)) ? 18 : 0 }}>
						<Text
							level={2}
							style={{ fontSize: 20, fontWeight: 510 }}
						>
							The Second Referee
						</Text>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 18 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Salutation</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.salutation ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.salutation ? secondReferee.salutation : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Family Name / Last Name</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.last_name ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.last_name ? secondReferee.last_name : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Given Name / First Name</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.first_name ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.first_name ? secondReferee.first_name : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Position</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.position ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.position ? secondReferee.position : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Department / Unit</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.department ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.department ? secondReferee.department : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Institution</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.organization ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.organization ? secondReferee.organization : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Relationship with Applicant</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.relationship ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.relationship ? secondReferee.relationship : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Institutional Email</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text
								type={_.isEmpty(secondReferee) ? '' : secondReferee.email ? '' : 'danger'}
								style={{ fontSize: 14, fontWeight: 400, marginRight: 0 }}
							>{_.isEmpty(secondReferee) ? '-' : secondReferee.email ? secondReferee.email : 'This field is required'}
							</Text>
						</Col>
					</Row>
					<Row
						justify="space-between"
						style={{ marginTop: 11 }}
					>
						<Col
							span={12}
						>
							<Text style={{ fontSize: 14, fontWeight: 510 }}>Contact No.</Text>
						</Col>
						<Col
							span={11}
							offset={1}
						>
							<Text style={{ fontSize: 14, fontWeight: 400 }}>{!_.isEmpty(secondReferee) && secondReferee.phone ? secondReferee.phone : '-'}</Text>
						</Col>
					</Row>
				</Col>
			</Row>

			<Row
				align="middle"
				style={{ marginTop: 32 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
					>Ready for Submission &nbsp;
					</Text>
				</Col>
			</Row>
			<Row style={{ marginTop: 20 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<ul style={{ lineHeight: 1.5, marginLeft: -15, fontSize: 14, fontWeight: 400 }}>
						<li>
							Please read the declaration and Personal Information Collection Statement, if appropriate, and PRC
							(People’s Republic of China) Addendum.
						</li>
						<li>
							Keep a record of your completed online application form before submission (print and save as PDF).
						</li>
						<li>
							After submission, you will receive an acknowledgement email with your online application number for
							future correspondence. Please include your application number in the subject line of your email for
							enquiries.
						</li>
					</ul>
				</Col>
			</Row>

			<Row
				align="middle"
				style={{ marginTop: 32 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 24, fontWeight: 700, color: colorPrimary }}
					>Submission &nbsp;
					</Text>
				</Col>
			</Row>
			<Row style={{ marginTop: 29 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Flex gap={5}>
						<div>
							<Checkbox
								onChange={(event) => setUnderstandCheck(event.target.checked)}
								checked={understandCheck}
								disabled={application.status === 'submitted' ? true : false}
							>
							</Checkbox>
						</div>
						<div>
							<Text>
								I understand that the information provided in this form and the submitted documents for the HKUST
								Engineering Summer Camp for Elite Students 2026 will be used by HKUST and viewed by the School of
								Engineering and its departments for the purpose of selection.
							</Text>
						</div>
					</Flex>
				</Col>
			</Row>
			<Row style={{ marginTop: 16 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Flex gap={5}>
						<div>
							<Checkbox
								onChange={(event) => setHerebyCheck(event.target.checked)}
								checked={herebyCheck}
								disabled={application.status === 'submitted' ? true : false}
							>
							</Checkbox>
						</div>
						<div>
							<Text>
								I hereby declare that the information provided in this form and the submitted documents is
								true, accurate and complete to the best of my knowledge.
							</Text>
						</div>
					</Flex>
				</Col>
			</Row>
			<Row style={{ marginTop: 16 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Flex gap={5}>
						<div>
							<Checkbox
								onChange={(event) => setAgreeCheck(event.target.checked)}
								checked={agreeCheck}
								disabled={application.status === 'submitted' ? true : false}
							>
							</Checkbox>
						</div>
						<div>
							<Text>
								I agree to abide by the rules of the Summer Camp and the rules stipulated in this application form. I understand my application
								may be disqualified if any of the information provided in the application form is false or incomplete.
							</Text>
						</div>
					</Flex>
				</Col>
			</Row>

			<Row
				align="middle"
				style={{ marginTop: 29 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 20, fontWeight: 590 }}
					>Personal Information Collection Statement &nbsp;
					</Text>
				</Col>
			</Row>
			<Row
				align="middle"
				style={{ marginTop: 5 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 14, fontWeight: 400 }}
					>The Hong Kong University of Science and Technology (HKUST / University) pledges to comply fully with the
						requirements of the Personal Data (Privacy) Ordinance, and your personal data is protected in accordance with
						the standard required by law. The personal data collected from you will be used by the HKUST School of
						Engineering (SENG) to inform you of updates, select candidates, and make necessary arrangements for activities
						for shortlisted participants regarding the HKUST Engineering Summer Camp for Elite Students 2026. It will also be
						used for sending admission-related information and may be provided to other relevant departments/offices
						within HKUST for administrative and academic purposes. We will not disclose any personal data provided by you
						to any external bodies or organizations unless you have been previously informed. For access to and modification
						of personal data held by SENG, please email <a href="mailto:sengpgevents@ust.hk">sengpgevents@ust.hk</a>.
					</Text>
				</Col>
			</Row>

			<Row
				align="middle"
				style={{ marginTop: 29 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 20, fontWeight: 590 }}
					>Personal Information Collection Statement - PRC Addendum &nbsp;
					</Text>
					<br />
					<Text>(It applies to individuals currently residing or located in the Chinese Mainland)</Text>
				</Col>
			</Row>
			<Row
				align="middle"
				style={{ marginTop: 5 }}
			>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Text
						level={2}
						style={{ fontSize: 14, fontWeight: 400 }}
					>The University collects your personal information (PI) directly from you when you apply for the HKUST
						Engineering Summer Camp for Elite Students 2026. HKUST will only collect, hold, use and disclose PI to enable
						SENG and department/offices to meet legal obligations and where it is reasonably necessary or related to the
						activities. The sensitive PI that may be collected from you is necessary for SENG to provide you with its various
						services. We will not transfer your PI to any third party unless your prior explicit consent has been obtained. Your
						PI is created, stored and transmitted securely in paper and electronic formats including databases provided by
						externally hosted and supported systems. The University will only store your PI within the time limit that is
						necessary for us to perform the service for you. For access to and rectification of your PI held by SENG, please
						email <a href="mailto:sengpgevents@ust.hk">sengpgevents@ust.hk</a>.
					</Text>
				</Col>
			</Row>

			<Row style={{ marginTop: 29 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
				>
					<Flex gap={5}>
						<div>
							<Checkbox
								onChange={(event) => {
									setReadAndAgreeCheck(event.target.checked);
									event.target.checked && setDeclinedCheck(!event.target.checked);
								}}
								checked={readAndAgreeCheck}
								disabled={application.status === 'submitted' ? true : false}
							>
							</Checkbox>
						</div>
						<div>
							<Text>
								I have read and agree to the Personal Information Collection Statement and, if applicable, the PRC Addendum.
							</Text>
						</div>
					</Flex>
				</Col>
			</Row>
			<Row style={{ marginTop: 13 }}>
				<Col
					xl={{ span: 22, offset: 1 }}
					lg={{ span: 22, offset: 1 }}
					md={24}
					sm={24}
					xs={24}
					style={{ marginTop: 20 }}
				>
					<ButtonGroupComponent
						currentStep={currentStep}
						saveDisabled={!understandCheck || !herebyCheck || !agreeCheck || !readAndAgreeCheck || submitDisabled}
						loadingSubmit={loadingSubmit}
						onSave={() => setConfirmation(true)}
						onPrevious={() => history.push(`/application?step=5&application_id=${query.application_id}`)}
						isOnReviewPage={true}
					/>
				</Col>
			</Row>
			<Confirmation
				loading={loadingSubmit}
				open={confirmation}
				onCancel={() => setConfirmation(false)}
				onOk={() => {
					application.status !== 'submitted'
						? submitApplication(applicationId)
						: history.push(`/application?step=7&application_id=${applicationId}`);
				}}
			>
				<Flex
					vertical
					gap={30}
				>
					<Text>
						You cannot make any changes once you have submitted your application.
					</Text>
				</Flex>
				<Flex
					vertical
					gap={30}
					style={{ marginTop: 20 }}
				>
					<Text>
						Are you sure you want to submit?
					</Text>
				</Flex>
			</Confirmation>

		</>
	);
};

export default ReviewAndSubmissionView;